export default __webpack_public_path__ + "static/media/5.4f5f0dfb.jpg";